import { AxiosRepo } from '@/helpers/interceptorsSetup';

const axiosInstance = AxiosRepo.getInstance();

export const actions = {
  getVetClients({ dispatch, commit, state }, credentials) {
    commit('load');
    return axiosInstance
      .post(`/ivs/AddressBook/getVetClients`, { T: Date.now() })
      .then(response => {
        commit('setVetClients', response);
      })
      .catch(error => {
        // console.log(error);
      });
  },
  saveClientData({ dispatch, commit, state }, form) {
    commit('load');
    return axiosInstance
      .post(`/ivs/AddressBook/saveClientData`, {...form.data, T: Date.now()})
      .then(response => {
        const responseData = response;
        if (
          responseData &&
          !!!isNaN(responseData.clientId) &&
          responseData.clientId !== 0
        ) {
          commit('updateVetClient', {
            data: {
              firstname: form.data.billingAddress.firstname,
              lastname: form.data.billingAddress.lastname,
              id: responseData.clientId
            },
            isPraxis: form.data.isPraxis,
            id: responseData.clientId
          });
          return Promise.resolve({
            clientId: responseData.clientId,
            clientName:
              form.data.billingAddress.firstname +
              ' ' +
              form.data.billingAddress.lastname
          });
        }
        return Promise.reject(undefined);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  getClient({ dispatch, commit, state }, payload) {
    commit('load');
    return axiosInstance
      .get(`/ivs/AddressBook/getClientInfo?clientId=${payload.id}&isVet=${payload.isVet}`)
      .then(response => {
        return Promise.resolve({
          success: true,
          data: response
        });
      })
      .catch(error => {
        return Promise.resolve({
          success: false,
          data: error
        });
      });
  },
  getClientPets({ dispatch, commit, state }, payload) {
    return axiosInstance
      .get(`/ivs/AddressBook/getClientPets?clientId=${payload.id}&isVet=${payload.isVet}`)
      .then(response => {
        return Promise.resolve({
          success: true,
          data: response
        });
      })
      .catch(error => {
        console.log(error);
      });
  },
  reorder({ dispatch, commit, state }, petId) {
    return axiosInstance
      .get(`/ivs/AddressBook/reorder?petId=${petId}`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.resolve({ success: false, error: error });
      });
  },
  uploadPicture({ dispatch, commit, state }, payload) {
    return axiosInstance
      .post(`/ivs/AddressBook/uploadPetPicture`, payload)
      .then(response => {
        return Promise.resolve({
          success: true,
          data: response
        });
      })
      .catch(error => {
        return Promise.resolve({
          success: false,
          data: error
        });
      });
  },
  assignPetToClient({ dispatch, commit, state }, payload) {
    return axiosInstance
      .post(`/ivs/AddressBook/assignPetToClient`, payload)
      .then(response => {
        return Promise.resolve({
          success: true,
          data: response
        });
      })
      .catch(error => {
        return Promise.resolve({
          success: false,
          data: error
        });
      });
  },
  checkCompleteAddress({ dispatch, commit, state }, payload) {
    const map = { street: 'street1', hn: 'street2', zip: 'post', city: 'city' };
    const postData = {
      street: payload.street1,
      city: payload.city,
      zip: payload.post,
      hn: payload.street2
    };
    return axiosInstance
      .post(`/AddressCheck/Default/getAddressStatus`, postData)
      .then(response => {
        if (response.hasOwnProperty('reason')) {
          response.reason = response.reason.map(r => map[r]);
        }
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.resolve({ success: false, reason: 'Error' });
      });
  },
  completeAddress({ dispatch, commit, state }, payload) {
    const postData = {
      street: payload.street1,
      city: payload.city,
      zip: payload.post
    };
    if (payload.field === 'street2') {
      return axiosInstance
        .post(`/AddressCheck/Default/getHousenumberInfo`, postData)
        .then(response => {
          return Promise.resolve({
            success: true,
            data: response
          });
        })
        .catch(error => {
          return Promise.resolve({
            success: false,
            data: error
          });
        });
    } else {
      const map = { city: 'City', street1: 'Street', post: 'Zip' };

      return axiosInstance
        .post(`/AddressCheck/Default/complete${map[payload.field]}`, {
          ...postData,
          street: payload.field === 'city' ? '' : postData.street
        })
        .then(response => {
          return Promise.resolve({
            success: true,
            data: response
          });
        })
        .catch(error => {
          return Promise.resolve({
            success: false,
            data: error
          });
        });
    }
  },
  completeAll({ dispatch, commit, state }, payload) {
    const postData = {
      street: payload.street1,
      city: payload.city,
      zip: payload.post
    };
    return axiosInstance
      .post(`/AddressCheck/Default/completeAll`, postData)
      .then(response => {
        return Promise.resolve({
          success: true,
          data: response
        });
      })
      .catch(error => {
        return Promise.resolve({
          success: false,
          data: error
        });
      });
  },
  getClientFormOptions() {
    return axiosInstance
      .get(`/ivs/AddressBook/getClientFormOptions`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  getAllowedCountries() {
    return axiosInstance
      .post(`/ivs/AddressBook/getAllowedCountries`, { T: Date.now() })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  deletePet({ dispatch, commit, state }, petId) {
    return axiosInstance
      .post(`/ivs/AddressBook/deletePet`, { petId })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  deleteClient({ dispatch, commit, state }, payload) {
    return axiosInstance
      .post(`/ivs/AddressBook/unlinkClient`, { clientId: payload.clientId })
      .then(response => {
        commit('deleteClient', payload);
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  getEmailAvailability({dispatch, commit, state}, payload) {
    return axiosInstance
        .post(`/ivs/AddressBook/getEmailAvailability`, {email: payload.email, clientId: payload.clientId, T: Date.now()})
        .then(response => {
          return Promise.resolve({
            success: true,
            data: response
          });
        })
        .catch(error => {
          return Promise.reject(error);
        });
  },
};
